import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {manager_mode: false, header: false, title:'fugafuga', required_login:false},

    },
    // {
    //     path: '/:locale',
    //     name: 'locale',
    //     component: { template: "<router-view />"},
    //     meta: {manager_mode: false, header: false, title:'fugafuga', required_login:false},

    //     children: [
    //         // {
    //         //     path: 'signup',
    //         //     name: 'signup',
    //         //     meta: {manager_mode: false, header: false, required_login:false},
    //         //     component: () => import(/* webpackChunkName: "about" */ '../views/SignUp.vue')
    //         // },
    //         {
    //             path: '',
    //             name: 'login',
    //             component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
                
    //         },
            
    //     ]
    // },
    
    {
        path: '/signup',
        name: 'signup',
        meta: {manager_mode: false, header: false, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/SignUp.vue')
    },
    
    {
        path: '/login',
        name: 'login',
        meta: {manager_mode: false, header: false, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
    },
    {
        path: '/lostpassword',
        name: 'lostpassword',
        meta: {manager_mode: false, header: false, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/LostPassword.vue')
    },
    {
        path: '/reset/:username/:token',
        name: 'reset-with-username-with-token',
        meta: {manager_mode: false, header: false, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/Reset.vue')
    },
    // {
    //     path: '/newlogin',
    //     name: 'newlogin',
    //     meta: {manager_mode: false, header: false, required_login:false},
    //     component: () => import(/* webpackChunkName: "about" */ '../views/NewLogin.vue')
    // },
    {
        path: '/logout',
        name: 'logout',
        meta: {manager_mode: false, header: false, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/Logout.vue')
    },
    // Scheduler for user
    {
        path: '/calendar',
        name: 'calendar',
        meta: {manager_mode: false, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/Calendar.vue')
    },
    {
        path: '/gcalendarcallback',
        name: 'gcalendarcallback',
        meta: {manager_mode: false, header: true, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/GCalendarCallback.vue')
    },
    
    // Scheduler for admin
    {
        path: '/heatmap',
        name: 'heatmap',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/HeatmapTest.vue')
    },
    // department settings for admin
    {
        path: '/departmentsetting',
        name: 'departmentsetting',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/DepartmentSetting.vue')
    },
    // department rule setting
    {
        path: '/departmentrulesetting',
        name: 'departmentrulesetting',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/DepartmentRuleSetting.vue')
    },
    {
        path: '/teamsetting',
        name: 'teamsetting',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/TeamSetting.vue')
    },
    // currently I dont use but I may use it in the future 
    {
        path: '/rulesetting',
        name: 'rulesetting',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/RuleSetting.vue')
    },
    // user creation
    {
        path: '/usermanagement',
        name: 'usermanagement',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/UserManagement.vue')
    },
    // day, night setting etc
    {
        path: '/userpropmanagement',
        name: 'userpropmanagement',
        meta: {manager_mode: true, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/UserPropertyManagement.vue')
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {manager_mode: false, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    },
    {
        path: '/googleauth',
        name: 'googleauth',
        meta: {manager_mode: false, header: true, required_login:true},
        component: () => import(/* webpackChunkName: "about" */ '../views/GoogleAuth.vue')
    },
    {
        path: '/contactus',
        name: 'contactus',
        meta: {manager_mode: false, header: true, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/ContactUs.vue')
    },
    {
        path: '/privacypolicy',
        name: 'privacypolicy',
        meta: {manager_mode: false, header: true, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPolicy.vue')
    },
    {
        path: '/termsofservice',
        name: 'termsofservice',
        meta: {manager_mode: false, header: true, required_login:false},
        component: () => import(/* webpackChunkName: "about" */ '../views/TermsOfService.vue')
    },
    {
        path: '/twitter',
        meta: {manager_mode: false, header: true, required_login:false},
        beforeEnter() { location.href = 'https://twitter.com/allshifter' }
    },
    {
        path: '/instagram',
        meta: {manager_mode: false, header: true, required_login:false},
        beforeEnter() { location.href = 'https://www.instagram.com/allshifter/' }
    },
    {
        path: '/facebook',
        meta: {manager_mode: false, header: true, required_login:false},
        beforeEnter() { location.href = 'https://www.facebook.com/allshifter' }
    },
    
    {
        path: '/octopt',
        meta: {manager_mode: false, header: true, required_login:false},
        beforeEnter() { location.href = 'https://www.octopt.com' }
    },
    {
        path: "*",
        meta: {manager_mode: false, header: true, required_login:false},
        component: () => import("../views/NotFound.vue")
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
